import { StyleSheet, View } from 'react-native';
import { theme } from '@socrait/react';

interface SetupProgressIndicatorProps {
  currentStep: number; // 1-6 for the 6 setup steps
  completedSteps?: number; // Number of completed steps (0-5)
}

export function SetupProgressIndicator({ currentStep, completedSteps = 0 }: SetupProgressIndicatorProps) {
  const totalSteps = 6;

  return (
    <View style={styles.container}>
      {Array.from({ length: totalSteps }, (_, index) => {
        const stepNumber = index + 1;
        let backgroundColor;

        if (stepNumber < currentStep || stepNumber <= completedSteps) {
          // Completed steps
          backgroundColor = theme.colors.primaryPurple;
        } else if (stepNumber === currentStep) {
          // Current step
          backgroundColor = theme.colors.navy;
        } else {
          // Future steps
          backgroundColor = theme.colors.gray;
        }

        return <View key={stepNumber} style={[styles.bar, { backgroundColor }]} />;
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: theme.spacing.large,
    paddingHorizontal: theme.spacing.xlarge,
  },
  bar: {
    flex: 1,
    height: 7,
    borderRadius: theme.borderRadius.xlarge,
  },
});
